import { useHistory, useParams } from 'react-router-dom';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  grid: {
    marginBottom: '45px',
  },
  cardRoot: {
    width: '235px',
    height: '180px',
    background: '#FFFFFF',
    marginTop: '20px',
    [theme.breakpoints.down('md')]: {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  cardAction: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  upgradeButton: {
    background: '#F5DE76',
    paddingTop: '10px',
    paddingBottom: '10px',
    paddingLeft: '20px',
    paddingRight: '20px',
    borderRadius: '2px',
  },
  cardButton: {
    paddingTop: '10px',
    paddingBottom: '10px',
    paddingLeft: '20px',
    paddingRight: '20px',
    position: 'relative',
    left: '49px',
    background: '#434E59',
    border: '3px solid #44D2F2',
    boxSizing: 'border-box',
    borderRadius: '30px',
    color: 'white',
    height: '30px',
    width: '120px',
  },
  title: {
    fontWeight: 600,
  },
}));

const MyProducts = () => {
  const classes = useStyles();
  const history = useHistory();
  const { portalId } = useParams<Record<string, string>>();

  return (
    <>
      <Typography className={classes.title} variant="h4">
        My Products
      </Typography>
      <Grid className={classes.grid} container spacing={2}>
        <Grid item sm={6} xs={12}>
          <Card className={classes.cardRoot} variant="elevation">
            <CardContent className={classes.cardContent}>
              <img alt="dashboard-frame" src="/dashboard-frame.svg" />
            </CardContent>
            <CardActions className={classes.cardAction} style={{ position: 'absolute' }}>
              <Button
                size="medium"
                onClick={() => history.push(`/home/${portalId}/vault`)}
                className={classes.cardButton}
                fullWidth
              >
                Vault
              </Button>
            </CardActions>
          </Card>
        </Grid>
        <Grid item sm={6} xs={12}>
          <Card className={classes.cardRoot}>
            <CardHeader />
            <CardContent className={classes.cardContent}>
              <Typography>Interested in getting more out of Trustate?</Typography>
            </CardContent>
            <CardActions className={classes.cardAction}>
              <Button size="small" className={classes.upgradeButton}>
                Upgrade
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default MyProducts;
